import { html } from 'lit';
import { Building2 } from 'lucide-static';
import { unsafeHTML } from 'lit/directives/unsafe-html.js';
import { state } from 'lit/decorators.js';
import { pdsCustomIconElement as customElement } from '../../../decorators/pds-icon';
import { PdsIcon } from '../PdsIcon';

@customElement('pds-icon-building')
export class PdsIconBuilding extends PdsIcon {
  @state()
  icon = Building2;

  render() {
    return html`${unsafeHTML(this.setIconAttributes())}`;
  }
}
